module.exports = "/static/fonts/OpenSans-Semibold.ttf";